import {
  Button,
  TextField,
  Box,
  Typography,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import axios from 'axios'

export default function ResourceCreatePage() {
  const navigate = useNavigate()
  const [title, setTitle] = useState('')
  const [type, setType] = useState<'local' | 'remote'>('local')

  const handleSubmit = () => {
    if (!title) {
      alert('Le titre est obligatoire.')
      return
    }
    const token = localStorage.getItem('token')
    axios
      .post(
        `${base_url}/resource/`,
        { title, type },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then((res) => {
        alert('Ressource créée ! Vous pouvez maintenant uploader des fichiers.')
        navigate(`/resource/${res.data.id}`)
      })
      .catch((error) =>
        alert('La création a échoué: ' + error.response?.data?.message)
      )
  }

  return (
    <PageAppBar pageName="Créer une Ressource">
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          p: 3,
          maxWidth: '600px',
          m: 'auto',
        }}
      >
        <Typography variant="h5">Nouvelle Ressource</Typography>
        <TextField
          required
          fullWidth
          label="Titre de la ressource"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <FormControl fullWidth>
          <InputLabel id="type-select-label">Type</InputLabel>
          <Select
            labelId="type-select-label"
            value={type}
            label="Type"
            onChange={(e) => setType(e.target.value as 'local' | 'remote')}
          >
            <MenuItem value="local">Local (fichiers uploadés)</MenuItem>
            <MenuItem value="remote">Distant (liens externes)</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          sx={{ mt: 2 }}
        >
          Créer et continuer
        </Button>
      </Box>
    </PageAppBar>
  )
}
